export const MODAL_ID = "checkout-url-modal";
